import { gql } from '@apollo/client'

import { SHOP_CART_FRAGMENT, SHOP_FRAGMENT } from '../fragments'

export const APPLY_GIFT_CARD = gql`
  mutation ApplyGiftCard($code: String!) {
    applyGiftCard(input: { code: $code }) {
      cart {
        ...ShopCart
      }
      shop {
        ...Shop
      }
    }
  }
  ${SHOP_CART_FRAGMENT}
  ${SHOP_FRAGMENT}
`

export const CANCEL_APPLYING_GIFT_CARD = gql`
  mutation CancelApplyingGiftCard($id: ID!) {
    cancelApplyingGiftCard(input: { id: $id }) {
      cart {
        ...ShopCart
      }
      shop {
        ...Shop
      }
    }
  }
  ${SHOP_CART_FRAGMENT}
  ${SHOP_FRAGMENT}
`
